import currency from "currency.js";

const currencies = {
  USD: (value: number) => currency(value, { symbol: "$", precision: 0 }),
  MXN: (value: number) => currency(value, { symbol: "$", precision: 0 }),
};

type Props = Readonly<{
  value: number;
  currencyCode: string;
}>;

export function FormattedCurrency({ value, currencyCode }: Props): JSX.Element {
  return (
    <>
      {currencies[currencyCode as keyof typeof currencies](value).format()}{" "}
      <span className="text-secondary">{currencyCode}</span>
    </>
  );
}
